import React from "react";
import ResetPasswordCard from "../components/cards/ResetPasswordCard";

const ResetPasswordPage = () => {
    return (
        <div
            className="w-100 bg-custom-tertiary pt-md-5"
            style={{minHeight: "100vh"}}
        >

            <div className="">
                <ResetPasswordCard/>
            </div>
        </div>
    )
}

export default ResetPasswordPage
